import React, {Fragment} from "react";
import Card from "../../components/card/Card";
import ModalConfirm from "../../components/ModalConfirm";
import ModalMsg from "../../components/ModalMsg";
import NsDataTable from "../../components/tabelle/NsDataTable";
import NsButtonActionsGroup from "../../components/buttons/NsButtonActionsGroup";
import NsButtonAction from "../../components/buttons/NsButtonAction";

export default function ConfGruppiUtenteView({
                                                 translate,
                                                 onRowDbClick,
                                                 showConfirm,
                                                 setShowConfirm,
                                                 eliminaGruppoUtente,
                                                 gruppoSel,
                                                 show,
                                                 setShow,
                                                 modalMsg,
                                                 loadingData,
                                                 gruppi,
                                                 onClickElimina,
                                                 bottoniDx,
                                             }) {

    return (
        <Card
            icon={'fas fa-users'}
            title={'Gruppi e permessi'}
            bottoniDx={bottoniDx}
        >
            <ModalConfirm
                show={showConfirm}
                handleClose={() => setShowConfirm(false)}
                handleOk={eliminaGruppoUtente}
                testo={"Sicuro di voler eliminare il Gruppo Utente: " + (gruppoSel && gruppoSel.codice) + "?"}/>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            {
                !loadingData &&
                <Fragment>
                    <NsDataTable
                        data={gruppi}
                        columns={[
                            {
                                name: translate('Codice'),
                                selector: row => row.codice,
                                sortable: true,
                                filtroHeader: {
                                    filterFunction: (item, filtro) => (item.codice && item.codice.toLowerCase().includes(filtro.toLowerCase()))
                                }
                            },
                            {
                                name: translate('Descrizione'),
                                selector: row => row.descrizione,
                                sortable: true,
                                filtroHeader: {
                                    filterFunction: (item, filtro) => (item.descrizione && item.descrizione.toLowerCase().includes(filtro.toLowerCase()))
                                }
                            },
                            {
                                name: translate('Note'),
                                selector: row => row.note,
                                sortable: true,
                                filtroHeader: {
                                    filterFunction: (item, filtro) => (item.note && item.note.toLowerCase().includes(filtro.toLowerCase()))
                                }
                            },
                            {
                                name: '',
                                selector: row => <NsButtonActionsGroup>
                                    <li>
                                        <NsButtonAction
                                            href={"/upd-gruppo-utente/" + row.id_gruppo_utente}
                                            label={"Modifica"}
                                            icona={"fas fa-pen"}
                                        />
                                    </li>
                                    <li>
                                        <NsButtonAction
                                            label={"Elimina"}
                                            icona={"fas fa-trash"}
                                            onClick={onClickElimina}
                                        />
                                    </li>
                                </NsButtonActionsGroup>,
                                sortable: false,
                                right: true,
                            }
                        ]}
                        addFiltri={false}
                        onRowDbClick={onRowDbClick}
                    />
                </Fragment>
            }
        </Card>
    );
}